import React, { useEffect } from 'react';
import '../Logos.css';

const OVERLAY_STYLES = {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0,0,0,0.5)',
    zIndex: 1000
}

const MODAL_STYLES = {
    position: 'fixed',
    top: '42%',
    left: '42%',
    transform: 'translate(-50%, -50%)',
    backgroundColor: '#FFF',
    padding: '50px',
    zIndex: 1000
}

const DeleteLogoEdit = ({ deleteEditOpen, setDeleteEditOpen, projectId, logoId, deleteLogo}) => {
    // if(logoId === undefined || projectId === undefined) return null;
    
    const handleClick = () => {
        deleteLogo(projectId, logoId);
        setDeleteEditOpen(false);
    }
    return (
        <div>
            <div onClick={() => setDeleteEditOpen(false)} style={OVERLAY_STYLES} />
            <div style={MODAL_STYLES} className='containerDeleteLogoEdit bg-gradient-to-r from-slate-800 to-violet-900 block p-4 text-white absolute'>
                <h2 className='Syne700 text-md h-[1rem] mt-2'>Do you want to delete this logo ?</h2>
                <div className='flex p-2 justify-around mt-4 text-gray-900'>
                    <button className='deleteLogoEditBtn' onClick={() => handleClick()}>Yes</button>
                    <button className='deleteLogoEditBtn' onClick={() => setDeleteEditOpen(false)}>No</button>
                </div>
            </div>
        </div>
    )
}

export default DeleteLogoEdit